import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSupportContactModal } from '../../../../actions/modal.js';
import { updateSupportContact, getWaitingArea } from '../../../../actions/waitingArea.js';
import Info from '../../info';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { Icon } from 'semantic-ui-react';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';

export default function SupportContactRightBottomPanel(props) {
  const dispatch = useDispatch();
  const [updatingSupportContact, setUpdatingSupportContact] = useState(false);

  useEffect(() => {
    // Force validation of the input fields
    let validation = () => {
      forceValidation(undefined, undefined, 'supportContactModal');
    };
    setTimeout(validation, 50);
  }, []);

  const closeModal = () => {
    dispatch(showSupportContactModal(false));
  };

  const clickSaveBtn = (event) => {
    if (!event.isTrusted) return;
    if (!window.$(event.target).hasClass('disable')) {
      saveChanges();
    }
  };

  const saveChanges = () => {
    setUpdatingSupportContact(true);

    let cb = (openModal) => {
      setUpdatingSupportContact(false);
      dispatch(showSupportContactModal(openModal));
    };
    queueESEvents(
      ESEventTypes.APICall,
      `In support contact save: ${props.waitingAreaId}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + props.waitingAreaId + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );
    dispatch(
      updateSupportContact(props.waitingAreaId, props.supportContactForm, (openModal) => {
        dispatch(getWaitingArea(props.waitingAreaId, cb(openModal)));
      })
    );
  };

  let saveClasses =
    props.defaultValueIsPicked === true
      ? 'ui labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull'
      : 'ui disable labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';

  let checkMarkIcon = props.defaultValueIsPicked === true ? 'checkmark  icon' : 'checkmark disable icon';

  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="ui actions mrbl mrtxxs max-width">
          <button
            type="button"
            data-group="supportContactModal"
            tabindex="2"
            onClick={clickSaveBtn}
            className={updatingSupportContact ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className={checkMarkIcon} data-group="supportContactModal" />
          </button>
          <button
            type="button"
            tabindex="2"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl max-width mrtxxs ">
          <button
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
      <div className="mrtl">
        <Info paragraphs={[APP.LANGUAGE.SupportContactModal.InfoOnTheRightOne]} />
      </div>
    </div>
  );
}
